
export interface IVideoAiChat {
	question: string;
	chatSessionId: string;
}

export enum MessageAuthor {
	USER,
	BOT
}

export enum MessageNodeType {
	PARAGRAPH = 'paragraph',
	CITATIONS = 'citations',
	TIMESTAMP = 'timestamp',
	TEXT = 'text'
}

export interface IChatState {
	messages: IChatMessage[],
	isWaitingForChatResponse: boolean,
	showStillWorkingMessage: boolean
}

export type IChatMessage = IChatUserMessage | IChatBotMessage;

export interface IChatUserMessage {
	author: MessageAuthor.USER;
	content: string;
	timestamp: Date;
}

export interface IChatBotMessage {
	author: MessageAuthor.BOT;
	content: IChatASTNode[];
	isErrorMessage?: boolean;
	timestamp: Date;
}

export type IChatASTNode = IChatParagraphNode | IChatCitationNode;

export interface IChatParagraphNode {
	type: MessageNodeType.PARAGRAPH;
	children: IChatParagraphChild[];
}

export type IChatParagraphChild = IChatTextNode | ITimestampNode;

export interface IChatTextNode {
	type: MessageNodeType.TEXT;
	content: string;
}

export interface ITimestampNode {
	type: MessageNodeType.TIMESTAMP;
	content: string;
}

export interface IChatCitationNode {
	type: MessageNodeType.CITATIONS;
	items: IChatCitation[];
}

export interface IChatCitation {
	timestamp: string;
	text: string;
}

